import React from "react";
import SingleImage from "../Gallaryprops";
// 2022
import Img221 from "../../../atrimages/pervious event images atri/2022/1.jpg";
import Img222 from "../../../atrimages/pervious event images atri/2022/2.jpg";
import Img223 from "../../../atrimages/pervious event images atri/2022/3.jpg";
import Img224 from "../../../atrimages/pervious event images atri/2022/4.jpg";
import Img225 from "../../../atrimages/pervious event images atri/2022/5.jpg";
import Img226 from "../../../atrimages/pervious event images atri/2022/6.jpg";
import Img227 from "../../../atrimages/pervious event images atri/2022/7.jpg";
import Img228 from "../../../atrimages/pervious event images atri/2022/8.jpg";
import Img229 from "../../../atrimages/pervious event images atri/2022/9.jpg";
import Img2210 from "../../../atrimages/pervious event images atri/2022/10.jpg";
import Img2211 from "../../../atrimages/pervious event images atri/2022/11.jpg";
import Img2212 from "../../../atrimages/pervious event images atri/2022/12.jpg";
import Img2213 from "../../../atrimages/pervious event images atri/2022/13.jpg";
import Img2214 from "../../../atrimages/pervious event images atri/2022/14.jpg";

export default function borealis22() {
  return (
    <div className="YearWise">
      <div className="2022">
        <h2>GLIMPSE OF BOREALIS - 2022</h2>
        <SingleImage gimage={Img227} title="President" />
        <SingleImage gimage={Img228} title="President" />
        <SingleImage gimage={Img229} title="President" />
        <SingleImage gimage={Img2210} title="President" />
        <SingleImage gimage={Img2212} title="President" />
        <SingleImage gimage={Img225} title="President" />
        <SingleImage gimage={Img221} title="President" />
        <SingleImage gimage={Img222} title="President" />
        <SingleImage gimage={Img223} title="President" />
        <SingleImage gimage={Img224} title="President" />
        <SingleImage gimage={Img2211} title="President" />
        <SingleImage gimage={Img226} title="President" />
        <SingleImage gimage={Img2213} title="President" />
        <SingleImage gimage={Img2214} title="President" />
      </div>

      <br />
      <br />
    </div>
  );
}
